interface ComingSoonLandingProps {
  title: string;
  description: string;
  visionDocAnchor: string;
}

export function ComingSoonLanding({ title, description, visionDocAnchor }: ComingSoonLandingProps) {
  return (
    <div className="content" style={{ maxWidth: 560, margin: "0 auto" }}>
      <div
        className="panel"
        style={{
          textAlign: "center",
          padding: "48px 32px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
        }}
      >
        <h1 style={{ margin: 0, fontFamily: "Montserrat", fontSize: 24, fontWeight: 800 }}>
          {title}
        </h1>
        <span className="badge-a yellow" style={{ fontSize: 12, padding: "4px 12px" }}>
          В разработке
        </span>
        <p
          style={{
            margin: 0,
            color: "var(--mnp-fg-2)",
            fontSize: 14,
            lineHeight: 1.6,
            maxWidth: 440,
          }}
        >
          {description}
        </p>
        <a
          className="btn-admin"
          href={visionDocAnchor}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: 8, textDecoration: "none" }}
        >
          Читать в Vision-доке →
        </a>
      </div>
    </div>
  );
}
